import { render, staticRenderFns } from "./MemoSet.vue?vue&type=template&id=4b596932&scoped=true"
import script from "./MemoSet.vue?vue&type=script&lang=js"
export * from "./MemoSet.vue?vue&type=script&lang=js"
import style0 from "./MemoSet.vue?vue&type=style&index=0&id=4b596932&prod&lang=css"
import style1 from "./MemoSet.vue?vue&type=style&index=1&id=4b596932&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b596932",
  null
  
)

export default component.exports